import React from 'react';
import './LoadingOverlay.css'; // Import styles for the overlay

const LoadingOverlay = () => {
  return (
    <div className="overlay">
      <div className="spinner"></div>
    </div>
  );
};

export default LoadingOverlay;
